import DownloadSoftwareModal from './DownloadSoftwareModal';

export default DownloadSoftwareModal;
